<template>
  <el-dialog width="520px" title="回收激活码"  :before-close="handleClickCancel" :close-on-press-escape="false"
             :close-on-click-modal="false" :visible.sync="retrieveAuthCodeVisible">
    <div class="details">
<!--      <p>有效期截止至{{retrieveInfo.end_date}}的{{retrieveInfo.product_name}}状态为{{retrieveInfo.status_text}}的激活码:{{retrieveInfo.license_code}}，是否确认回收?</p>-->


      <p>激活码: {{retrieveInfo.license_code}}</p>
      <p>有效期截止: {{convertToCurrentTimezone(retrieveInfo.end_date,'/','datetime')}}</p>
      <p>状态: {{retrieveInfo.status_text}}</p>


    </div>
    <div slot="footer">
      <el-button  size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button  size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">确认回收</el-button>
    </div>
  </el-dialog>
</template>
<script>

import { adminRecoveryLicenseCode} from '@/api/api'
import {mapState} from "vuex";
import {convertToCurrentTimezone} from '@/utils'
export default {
  name: 'copy_auth_code',
  props: {
    retrieveAuthCodeVisible: {
      type: Boolean,
      default: false,
    },
    retrieveInfo: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      loading:false,
      BtnDisabled: false,
    }
  },

  created() {

  },
  computed: {
    ...mapState(['adminUserInfo']),

  },
  mounted() {

  },
  methods: {
    convertToCurrentTimezone(utcTime,separator,type) {
      return convertToCurrentTimezone(utcTime,separator,type);
    },
    handleClickConfirm(){
      let postData = {
        license_id: this.retrieveInfo.license_id,
      }
      this.BtnDisabled = true
      adminRecoveryLicenseCode(postData).then(res => {
        if (res.code === 200) {
          this.$message({
            message: res.message,
            type: 'success',
            duration: 1000,
            onClose: () => {
              this.BtnDisabled = false
              this.$emit('success')
              this.$emit('update:retrieveAuthCodeVisible', false)
            }
          })
        }else{
          this.BtnDisabled = false
        }
      }).catch((e) => {
        this.BtnDisabled = false
      })
    },


    //取消事件
    handleClickCancel() {
      //关闭对话框
      this.$emit('update:retrieveAuthCodeVisible', false)
    },


  },

}
</script>
<style lang="scss" scoped>

.details p{
  line-height: 22px;
  margin-bottom: 5px;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
}
.details h5{
  line-height: 22px;
  margin-bottom: 16px;
  color: rgba(51, 51, 51, 1);
  font-size: 16px;
}
</style>
